import React, { useEffect, useState } from "react";
import { useMasterQuery } from "../../../api/query/useMasterQuery";
import "./pager.scss";
const Paginations = () => {
  const range = 5;
  const [count] = useState([
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
  ]);
  const [current, setCurrent] = useState(1);
  const [min, setMin] = useState(1);
  const [max, setMax] = useState(range);

  useEffect(() => {}, []);

  const lastPage = () => {
    setCurrent(count.length);
    setMin(count.length - (range - 1));
    setMax(count.length);
  };
  const firstPage = () => {
    setCurrent(1);
    setMin(1);
    setMax(range);
  };
  const nextPage = () => {
    if (current < count.length) {
      setCurrent((pre) => pre + 1);
      // if (max < count.length && min >= 0&&count.length >=5) {
      //     setMax(pre => pre + 1)
      //     setMin(pre => pre + 1)
      // }
      if (count.length % range == 0) {
        if (
          max < count.length &&
          current % range == 0 &&
          count.length - current >= range
        ) {
          setMax((pre) => current + range);
          setMin((pre) => current + 1);
        }
      } else if (count.length % range !== 0) {
        if (
          max < count.length &&
          current % range == 0 &&
          count.length - current >= range
        ) {
          setMax((pre) => current + range);
          setMin((pre) => current + 1);
        } else if (
          max < count.length &&
          count.length - current < range + Math.floor(range / 2)
        ) {
          setMax((pre) => pre + 1);
          setMin((pre) => pre + 1);
        }
      }
    }
  };
  const previousPage = () => {
    if (current >= min && current !== 1) {
      setCurrent((pre) => pre - 1);
      if (max <= count.length + 1 && min > 1) {
        setMax((pre) => pre - 1);
        setMin((pre) => pre - 1);
      }
      // if(max <= count.length &&current%range==0){
      //     setMax(pre => current)
      //     setMin(pre => current-(range))
      // }
      // else if(max < count.length&&((count.length-current)<5)){
      //     setMax(pre=>pre-1)
      //     setMin(pre=>pre-1)
      // }
    }
  };
  const onNumberClick = (CV) => {
    setCurrent(CV);
  };
  const forlooping = async () => {
    for (let i = 1; i <= 10; i++) {
      setTimeout(() => {}, 5000);
    }
  };
  useEffect(() => {
    forlooping();
  }, []);

  return (
    <span className="paginations">
      <button
        disabled={current === 1}
        className="paginations__btn"
        onClick={() => firstPage()}
      >
        <i className="fa-solid fa-angles-left"></i>{" "}
      </button>
      <button
        disabled={current === 1}
        className="paginations__btn"
        onClick={() => previousPage()}
      >
        {" "}
        <i className="fa-solid fa-chevron-left"></i>{" "}
      </button>
      <span>
        {" "}
        {count
          .filter((data) => data >= min && data <= max)
          .map((ar) => (
            <button
              className="paginations__Nbtn"
              key={ar}
              style={{ background: current == ar ? "#79d0ff" : "" }}
              onClick={() => onNumberClick(ar)}
            >
              {" "}
              {ar}{" "}
            </button>
          ))}
      </span>
      <button
        disabled={current === count.length}
        className="paginations__btn"
        onClick={() => nextPage()}
      >
        <i className="fa-solid fa-chevron-right"></i>
      </button>
      <button
        disabled={current === count.length}
        className="paginations__btn"
        onClick={() => lastPage()}
      >
        {" "}
        <i className="fa-solid fa-angles-right"></i>{" "}
      </button>
    </span>
  );
};

export default Paginations;
